module.exports = __webpack_public_path__ + "static/media/glyphicons-halflings-regular.f4769f9b.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap/fonts/glyphicons-halflings-regular.eot
// module id = 3836
// module chunks = 68